import { DATASET_FOR_UI_CONFIG_REFRESH_ON_FUEL_PLAN } from 'api/dataset/dataset.api'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import SystemMessageBanner from 'ui/components/SystemMessageBanner/SystemMessageBanner'
import View from 'ui/components/View/View'
import QueueProgressBar from 'ui/molecules/QueueProgressBar/QueueProgressBar'
import UiConfig from 'ui/uiConfig/UiConfig'
import OptimizeModuleHeader from 'views/OptimizeView/components/OptimizeModuleHeader/OptimizeModuleHeader'
import { fuelPlanViewRange } from './store/FuelPlanStore'

export default function FuelPlanView(): ReactElement {
  const { t } = useTranslation()

  const [startTime, endTime] = fuelPlanViewRange('month')

  return (
    <View
      header={
        <OptimizeModuleHeader
          title={t('Scenario planning')}
          optJobType="fuel_plan"
          optimizePermission="edit_fuelplan_module"
          showAccumulatorLevels={true}
          showOptimizeButton={true}
          showAutomaticOptimizationToggleButton={false}
          showProductionPlanOutOfDate={true}
          showLatestSubtypeOptimizationInfoBox={true}
          showOptimizationFailedGuide={true}
          showFilterButton={true}
          showDateRangeSwitch={false}
          showActiveDeviationSettings={false}
          showPublishOptimizationButton={false}
          showLatestPublishedOptimizationInfoBox={false}
        />
      }
    >
      <SystemMessageBanner module="fuelplan" />
      <UiConfig
        type="fuel_plan"
        datasetStartTime={startTime}
        datasetEndTime={endTime}
        datasetRefreshToken={DATASET_FOR_UI_CONFIG_REFRESH_ON_FUEL_PLAN}
      />
      <QueueProgressBar />
    </View>
  )
}
